"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gets a regular expression, or a new stateless regular expression if the input is stateful.
 * @param {RegExp} [expression] An regular expression
 * @returns {RegExp} A stateless regular expression
 */
var getRegExp = function (expression) {
    // Return a new RegExp if lastIndex is not 0 to ensure the returned RegExp is stateless
    return expression.lastIndex !== 0
        ? new RegExp(expression)
        : expression;
};
exports.default = getRegExp;
